import * as React from 'react';
import {
    ShowButton,
    List,
    Datagrid,
    TextField,
    EditButton,
    TextInput,
    Filter,
    DateField,
} from 'react-admin';

const InstanceFilter = props => (
    <Filter {...props}>
        <TextInput label="Search" source="q" />
    </Filter>
);

const InstanceList = props => (
    <List {...props} filters={<InstanceFilter />}>
        <Datagrid>
            <TextField source="id" />
            <TextField source="name" />
            <TextField source="slug" />
            <DateField source="last_materialized" />
            <DateField source="materialized_until" />
            <DateField source="created_at" />
            <DateField source="updated_at" />
            <EditButton />
            <ShowButton />
        </Datagrid>
    </List>
);

export default InstanceList;